import { render, staticRenderFns } from "./PushMessageTemplateDetail.vue?vue&type=template&id=5cb9f414&scoped=true&"
import script from "./PushMessageTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./PushMessageTemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./PushMessageTemplateDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PushMessageTemplateDetail.vue?vue&type=style&index=1&id=5cb9f414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb9f414",
  null
  
)

export default component.exports